import "./suppressConsole";

import React from "react";
import ReactDOM from "react-dom";

import firebase from "js/firebase";
import App from "./App";

//
// entry point
//

// debug
window.firebase = firebase;

// firebase
firebase.initializeApp(window.baiFirebase.config);

const init = async () => {
    // We have to import late because the import depends on firebase being setup first.
    const { IntegratorController } = await import("common/integrators/IntegratorController");
    await IntegratorController.initApp();

    // react
    const root = document.createElement("div");
    root.id = "react-root";
    root.style.display = "contents";
    document.body.appendChild(root);

    ReactDOM.render(<App />, root);
};

init();
